<script lang="ts" setup>
import { ref, computed } from 'vue';
type TitleKeys = '편리한' | '쾌적한' | '친절한' | '안전한';
interface List {
  key: TitleKeys;
  title: string;
  content: string;
  image: string;
}
const IMAGE_OPTION = '?auto=compress&w=2400&fit=crop&h=1240';

const list: List[] = [
  {
    key: '편리한',
    title: '편리한 디포스트',
    content:
      '수신만 가능했던 공간에서 이제 택배,퀵 발송이 가능해 집니다. 회사의 니즈에 따라 등기, 국제우편, 기업행낭, 포장용품구매, 구내배송, 세탁, 세차 등 다양한 컨시어지 서비스들을 추가할 수 있습니다.',
    image: `https://dvercorp-co-kr.imgix.net/dpost/home/benefit_01.png${IMAGE_OPTION}`,
  },
  {
    key: '쾌적한',
    title: '쾌적한 디포스트',
    content:
      '택배가 쌓여있던 건물로비, 창고 같던 문서수발실은 이제 잊어 주세요. 디포스트는 건물에 어울리는 최적의 인테리어와 이용자(기사,입주사) 중심 동선 설계로 쾌적한 서비스 공간으로 탈바꿈합니다.',
    image: `https://dvercorp-co-kr.imgix.net/dpost/home/benefit_02.png${IMAGE_OPTION}`,
  },
  {
    key: '친절한',
    title: '친절한 디포스트',
    content:
      '기다리던 택배를 받는 설렘을, 급한 서류를 퀵으로 보내는 초조함을 가장 가까이에서 이해하는 디포스트이길 바라는 마음으로 본사에서 전문 서비스 교육을 받은 매니저가 근무합니다.',
    image: `https://dvercorp-co-kr.imgix.net/dpost/home/benefit_03.png${IMAGE_OPTION}`,
  },
  {
    key: '안전한',
    title: '안전한 디포스트',
    content:
      '수기로 관리되던 과거의 문서수발실에서, 모든 것이 디지털화됩니다. 임직원의 정보는 암호화되고, 수신 물류 입고와 물품 수령, 발신 물류와 물품 위치정보까지 모든 정보가 트래킹이 가능해집니다.',
    image: `https://dvercorp-co-kr.imgix.net/dpost/home/benefit_04.png${IMAGE_OPTION}`,
  },
];
const activeItem = ref<TitleKeys>('편리한');
const selectedItem = computed(() => {
  return list.find((item) => item.key === activeItem.value);
});
</script>

<template>
  <section class="container benefit">
    <div class="benefit__title">
      <div class="benefit__title-sub">Benefits for you</div>
      <div class="benefit__title-main">이제, 디포스트의 {{ '\n' }} 혜택을 누려보세요.</div>
    </div>

    <div
      class="benefit__list"
      aria-label="디포스트 혜택 목록"
    >
      <button
        class="benefit__list-button"
        v-for="item in list"
        :key="item.key"
        :class="{ 'benefit__list-button--active': activeItem === item.key }"
        @click="activeItem = item.key"
      >
        {{ item.key }}
      </button>
    </div>

    <div
      class="benefit__content"
      aria-label="디포스트 혜택 내용"
    >
      <div class="benefit__content-title">{{ selectedItem!.title }}</div>
      <div class="benefit__content-content">{{ selectedItem!.content }}</div>
      <img
        class="benefit__content-image"
        :src="selectedItem!.image"
        :alt="`${selectedItem!.title} 이미지`"
      />
    </div>
  </section>
</template>

<style lang="scss" scoped>
.benefit {
  @apply mx-auto flex flex-col gap-12;
  @apply desktop:gap-12;

  &__title {
    @apply text-center;

    &-sub {
      @apply text-primary text-xl font-bold pb-6;
      @apply desktop:text-2xl;
    }
    &-main {
      @apply text-3xl font-black text-center leading-[1.4] whitespace-pre-wrap;
      @apply desktop:whitespace-nowrap desktop:text-5xl;
    }
  }

  &__list {
    @apply grid grid-cols-2 grid-rows-2 mx-auto gap-4 items-center;
    @apply desktop:max-w-[80%] desktop:mx-auto desktop:grid-rows-1 desktop:grid-cols-4;

    &-button {
      @apply bg-white text-black9 px-12 py-3 h-fit w-fit border-[3px] rounded-[42px];
    }
    &-button--active {
      @apply bg-black9 text-white;
      @apply transition-all;
    }
  }

  &__content {
    @apply flex flex-col gap-6 transition-opacity;
    @apply desktop:gap-8;
    &-title {
      @apply text-center font-black text-2xl;
      @apply desktop:text-3xl;
    }
    &-content {
      @apply max-w-[640px]  mx-auto;
      @apply text-sm font-semibold text-center;
      word-break: keep-all;
    }
    &-image {
      @apply max-w-[1200px] w-full rounded-[30px] mx-auto;
    }
  }
}
</style>
